import { CookiesConstants } from "utils/constants";
import { setCookie } from "utils/nookies";
import { NextPageContextEnhanced } from "../../types/page";



export function applyCountryCode(context: NextPageContextEnhanced) {

  if (!context.isChangeCountryPage) {
    setCookie(context, CookiesConstants.COUNTRY, context.countryCode);
  }
}
